<template>
  <!-- offer -->
  <div
    class="detail"
    v-if="dataDecrypt.action === 'U' ? is_show = true : is_show = false"
  >
    <!-- 基本信息 -->
    <ax-panel :noTitle="true">
      <van-cell
        title="姓名"
        :value="dataDecrypt.header.last_name + dataDecrypt.header.first_name"
      ></van-cell>
      <van-cell
        title="年龄"
        :value="dataDecrypt.header.age"
      ></van-cell>
      <van-cell
        title="员工类别"
        :value="dataDecrypt.header.empl_class_description"
      ></van-cell>
      <van-collapse v-model="activeNames1">
        <van-collapse-item
          class="remark"
          title='招聘说明'
          name="remarks1"
          style="padding-right:0.3rem;"
          value=""
        ><span style="color:#000">{{dataDecrypt.header.comments ? dataDecrypt.header.comments : '无'}}</span></van-collapse-item>
      </van-collapse>
    </ax-panel>
    <!-- 重新雇佣信息 -->
    <ax-panel
      v-if="dataDecrypt.header.qh_reset === 'Y' ? is_reset = true : is_reset = false"
      title="重新雇佣信息"
    >
      <van-cell
        title="离职时长"
        :value="dataDecrypt.qh_hr_001_hd06.qh_achive_max_val + '年'"
      ></van-cell>
      <van-cell
        title="薪酬涨幅"
        :value="dataDecrypt.qh_hr_001_hd06.descr10"
      ></van-cell>
      <van-cell
        v-if="dataDecrypt.qh_hr_001_hd06.qh_major_level_description"
        title="离职前专业层级"
        :value="dataDecrypt.qh_hr_001_hd06.qh_major_level_description"
      ></van-cell>
      <van-cell
        v-if="dataDecrypt.qh_hr_001_hd06.qh_jobmanage_level_description"
        title="离职前管理层级"
        :value="dataDecrypt.qh_hr_001_hd06.qh_jobmanage_level_description"
      ></van-cell>
      <van-cell
        title="重新雇佣审批意见"
        class="recruits"
      >
      </van-cell>
      <div class="recruit">
        {{dataDecrypt.qh_hr_001_hd06.qh_reh_result_description}}
      </div>
    </ax-panel>
    <!-- 所属部门 -->
    <ax-panel :noTitle="true">
      <div style="position:relative">
        <van-cell title="所属部门">
          {{dataDecrypt.header.deptid_description}}
          <span
            v-show="dataDecrypt.field_special_deal.qh_hc_over==='Y'"
            style="color:red"
          >(超编)
          </span>
        </van-cell>
      </div>
      <van-cell
        title="职位"
        :value="dataDecrypt.header.posn_descr"
      ></van-cell>
      <van-cell
        title="层级"
        :value="dataDecrypt.header.qh_major_level_description ? dataDecrypt.header.qh_major_level_description : dataDecrypt.header.qh_jobmanage_level_description"
      ></van-cell>

    </ax-panel>
    <!-- 增长 -->
    <ax-panel :noTitle="true">
      <van-cell
        title="增长%"
        class="panel"
        v-if="dataDecrypt.qh_hr_001_hd04"
      >
        <van-notice-bar
          class="ttc"
          color="#1989fa"
          background="#fff"
          left-icon="info-o"
          @click="showTTC"
        >TTC</van-notice-bar>
        <van-notice-bar
          class="tp"
          color="#1989fa"
          background="#fff"
          left-icon="info-o"
          @click="showTP"
        >TP</van-notice-bar>
        <van-notice-bar
          class="cr"
          color="#1989fa"
          background="#fff"
          left-icon="info-o"
          @click="showCR"
        >C/R值</van-notice-bar>
      </van-cell>
      <van-cell
        title="TTC增长"
        v-if="dataDecrypt.qh_hr_001_hd04[0].qh_gains_ttc"
      ><span :class="dataDecrypt.field_special_deal.qh_gains_ttc_redmark == 'Y' ? 'text_red' : ''">{{ dataDecrypt.qh_hr_001_hd04[0].qh_gains_ttc }}</span></van-cell>
      <van-cell
        title="TP增长"
        v-if="dataDecrypt.qh_hr_001_hd04[0].qh_gains_tp"
      ><span :class="dataDecrypt.field_special_deal.qh_gains_tp_redmark == 'Y' ? 'text_red' : ''">{{ dataDecrypt.qh_hr_001_hd04[0].qh_gains_tp }}</span></van-cell>
      <van-cell title="C/R值TTC" v-if="dataDecrypt.qh_hr_001_hd04[0].qh_cr_ttc"><span :class="dataDecrypt.field_special_deal.qh_cr_ttc_redmark == 'Y' ? 'text_red' : ''">{{dataDecrypt.qh_hr_001_hd04[0].qh_cr_ttc}}</span></van-cell>
      <van-cell title="C/R值TP" v-if="dataDecrypt.qh_hr_001_hd04[0].qh_cr_tp"><span :class="dataDecrypt.field_special_deal.qh_cr_tp_redmark == 'Y' ? 'text_red' : ''">{{dataDecrypt.qh_hr_001_hd04[0].qh_cr_tp}}</span></van-cell>
      <van-cell
        title="目前TTC"
        :value="dataDecrypt.qh_hr_001_hd04[0].qh_annual_tot_inc + '元'"
      ></van-cell>
      <van-cell
        title="目前TP"
        :value="dataDecrypt.qh_hr_001_hd04[0].qh_tp_comprate + '元'"
      ></van-cell>
      <van-cell
        title-style="color:rgba(0, 0, 0, 0.9);"
        title="入职后建议TTC"
        :value="dataDecrypt.qh_hr_001_hd05[0].qh_annual_tot_inc + '元'"
      ></van-cell>
      <van-cell
        title-style="color:rgba(0, 0, 0, 0.9);"
        title="入职后建议TP"
        :value="dataDecrypt.qh_hr_001_hd05[0].qh_tp_comprate + '元'"
      ></van-cell>
    </ax-panel>
    <!-- 绩效考核方案 -->
    <ax-panel :noTitle="true">
      <van-cell
        class="achievement"
        title="绩效考核方案"
        :value="dataDecrypt.header.qh_epm_type_description"
      ></van-cell>
      <van-cell
        title="月薪"
        :value="dataDecrypt.header.qh_overall_salary  + '元'"
      ></van-cell>
      <van-cell
        title="月基本工资"
        v-if="dataDecrypt.header.qh_fixed_pay ? basic_salary= true: basic_salary= false"
      ><span :class="dataDecrypt.field_special_deal.qh_rs_comprate_redmark == 'Y' ? 'text_red' : ''">{{ dataDecrypt.header.qh_fixed_pay }}元</span></van-cell>
      <van-cell
        title="月度奖金"
        v-if="dataDecrypt.header.qh_vary_pay > 0 ? monthly_onus= true :  monthly_onus = false"
        :value="dataDecrypt.header.qh_vary_pay + '元'"
      ></van-cell>
      <!-- 年奖基数 -->
      <van-cell
        class="base"
        :title='dataDecrypt.field_special_deal.qh_year_pay_label'
        :value="dataDecrypt.header.qh_year_pay + '元'"
        v-if="dataDecrypt.field_special_deal.qh_year_pay_display === 'Y' && dataDecrypt.header.qh_year_pay !== '0' ? year_display = true : year_display = false"
      ></van-cell>
      <!-- 年奖基数备注 -->
      <van-collapse v-model="activeNames2">
        <van-collapse-item
          class="remark"
          :title='dataDecrypt.field_special_deal.qh_comment_label'
          v-if="dataDecrypt.header.qh_year_pay === '0' ? is_yearPay= false : is_yearPay=true"
          name="remarks2"
          style="padding-right:0.3rem;"
          value=""
        ><span style="color:#000">{{dataDecrypt.header.qh_comment}}</span></van-collapse-item>
      </van-collapse>
    </ax-panel>
    <!-- 其他激励奖金 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_stock  === 'Y' ? is_excitation=true : is_excitation=false"
    >
      <van-cell
        :title='dataDecrypt.field_special_deal.qh_stock_number_label'
        :value="dataDecrypt.header.qh_stock_number + dataDecrypt.field_special_deal.qh_stock_number_unit_label"
      ></van-cell>
      <van-cell
        v-if="Number(dataDecrypt.header.qh_stock_cofnumber) > 0"
        title="目标总金额"
        :value="dataDecrypt.header.qh_stock_cofnumber + '元'"
      ></van-cell>
      <van-collapse v-model="activeNames">
        <van-collapse-item
          class="remark"
          title='其他激励备注'
          name="remarks"
          style="padding-right:0.3rem;"
          value=""
        ><span style="color:#000">{{dataDecrypt.header.qh_stock_comment}}</span></van-collapse-item>
      </van-collapse>
    </ax-panel>
    <!-- 特殊报销 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_spec === 'Y' ? is_reimb=true : is_reimb=false"
    >
      <van-cell
        title="特殊报销"
        :value="dataDecrypt.header.qh_spec_reimb_sal"
      ></van-cell>
    </ax-panel>
    <!-- 特殊奖金金额 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_special_bons === 'Y' ? is_bons=true :is_bons= false "
    >
      <van-cell
        title="特殊奖金金额"
        :value="dataDecrypt.header.qh_special_bonus"
      ></van-cell>
    </ax-panel>
    <!-- 签字费总额 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_cntr_end_bns === 'Y' ? true : false "
    >
      <van-cell
        title="签字费总额"
        :value="dataDecrypt.header.qh_sign_bonus"
      ></van-cell>
    </ax-panel>
    <!-- 发放节奏 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_cntr_end_bns === 'Y' ? true : false "
    >
      <van-cell
        title="发放节奏"
        :value="dataDecrypt.header.qh_pay_rhythm_description"
      ></van-cell>
    </ax-panel>
    <!-- 最低服务期 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_cntr_end_bns === 'Y' ? true : false "
    >
      <van-cell
        title="最低服务期"
        :value="dataDecrypt.header.qh_mini_ser_period_description"
      ></van-cell>
    </ax-panel>
    <!-- 满约奖金额 -->
    <!-- <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_cntr_end_bns === 'Y' ? true : false "
    >
      <van-cell
        title="满约奖金额"
        :value="dataDecrypt.header.qh_special_bonus"
      ></van-cell>
    </ax-panel> -->
    <!-- 特批备注 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_spaprpass === 'Y'"
    >
      <van-cell title="特批流程审批状态" >通过</van-cell>
      <van-cell>
        <p class="title">特批备注</p>
        <p class="desc">{{ dataDecrypt.header.qh_spcappr_note }}</p>
      </van-cell>
    </ax-panel>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import watermark from '../../utils/warterMark';
export default {
  props: ['data'],
  data() {
    return {
      activeNames1: ['remarks1'],
      activeNames2: ['remarks2'],
      activeNames: ['remarks'],
      no_border: true,
      is_reset: false,
      is_bons: false,
      is_reimb: false,
      is_show: false,
      is_excitation: false,
      year_display: false,
      is_yearPay: false,
      basic_salary: false,
      monthly_onus: false,
      dataDecrypt: {
        header: {},
        field_special_deal: {}
      }
    };
  },
  watch: {
    data() {
      this.dataDecrypt = JSON.parse(this.Decrypt(this.data));
      // console.log(this.dataDecrypt);
      this.$emit('reciveData', this.dataDecrypt);
      // 水印
      this.$nextTick(() => {
        const name = this.dataDecrypt.current_user;
        const now = new Date();
        const date = `${now.getFullYear()}/${
          now.getMonth() + 1
        }/${now.getDate()} ${now.getHours()}:${
          now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
        }`;
        watermark.set(date + name);
      });

      if (this.dataDecrypt.action === 'V') {
        this.$dialog
          .alert({
            message: '已完成的审批暂时无法查询请知悉'
          })
          .then(() => {
            console.log('offer已审批');
          });
      }
    }
  },
  mounted() {
    if (typeof this.data == 'string') {
      this.dataDecrypt = this.Decrypt(this.data);
      this.$emit('reciveData', this.dataDecrypt);
    }
  },
  methods: {
    showTTC() {
      this.$toast('target total cash 目标总现金收入');
    },
    showTP() {
      this.$toast('total package 年度目标总收入');
    },
    showCR() {
      this.$toast('薪资比率 Comparative Rate ，个人薪酬/薪酬中值');
    },
    Decrypt(word) {
      //数据解密
      const key = CryptoJS.enc.Utf8.parse('A-16-Byte-keyVal');
      const iv = CryptoJS.enc.Utf8.parse('A-16-Byte-String');

      let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      return decryptedStr.toString();
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  margin-left: -2.8rem;
}
.van-cell .van-cell__title {
  width: 4rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.panel {
  position: relative;
  .ttc {
    width: 2rem;
    position: absolute;
    left: -2.7rem;
    top: -0.2rem;
  }
  .tp {
    width: 2rem;
    position: absolute;
    left: -0.7rem;
    top: -0.2rem;
  }
  .cr {
    width: 2rem;
    position: absolute;
    left: 1.2rem;
    top: -0.2rem;
  }
}
.achievement .van-cell__value {
  color: #499ff5;
}
.recruits {
  border-bottom: none;
}
.recruit {
  padding: 0em 0.42667rem 0.26667rem;
  line-height: 0.5rem;
  font-size: 0.35rem;
}
.remark {
  .van-collapse-item__content {
    color: rgba(0, 0, 0, 0.9);
  }
}
.title{
  color: rgba(0, 0, 0, 0.3);
  font-size: 0.4rem;
  padding-left: 0.42667rem;
  text-align: left;
  margin-bottom: 10px;
}
.desc {
  color: #000000;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
.text_red {
  color: red;
}
</style>